/**
 * Current Voyage view
 * The main view in Voyage. Initializes all other view components on
 *
 */

var VRC = VRC || {};
VRC.CurrentVoyageView = (function () {

	var init = function () {

		var currentVoyage = VRC.CurrentVoyage.getCurrentVoyage();
		var voyage = currentVoyage.toJson();
		var $currentVoyageContainer = $('#current_voyage_info');
		var missionTypes = VRC.MissionTypeService.getMissionTypes();

		var $currentVoyage = $(WELL.Handlebars.VRC.current_voyage_info({missionTypes: missionTypes, voyage: voyage}));
		$currentVoyageContainer.html($currentVoyage);
		addEventsHandler($currentVoyageContainer);

		VRC.ListVoyagesView.init();
		$('#voyage-submenu__listvoyages-trigger').unbind('click').click(function () {
			VRC.ListVoyagesView.show();
		});

	};

	var addEventsHandler = function ($currentVoyageContainer) {
		addOnMissionTypeChange($currentVoyageContainer);

	};

	/**
	 * Changes the missionType, and gives an alert if some of the event logs are not in the new list.
	 * @param $currentVoyageContainer The container for more effective DOM query.
	 */
	var addOnMissionTypeChange = function ($currentVoyageContainer) {
		var $currentMissionType = $currentVoyageContainer.find('#current_voyage__select');

		$currentMissionType.unbind('change').change(function ($event) {
			var _this = this;
			var target = $event.target;
			var currentVoyage = VRC.CurrentVoyage.getCurrentVoyage();

			//We save the old missionType incase reset
			var oldMissionType = currentVoyage.getMissionType();

			//set new missionType
			currentVoyage.setMissionType(target.value);
			VRC.MissionTypeService.init();
			var invalidEvents = VRC.MissionTypeService.getInvalidEvents();

			var invalidSubEvents = VRC.MissionTypeService.getInvalidSubEvents();



			//There are events or sub-events in log which are invalid in the new mission type
			if (invalidEvents.length > 0 || invalidSubEvents.length > 0) {
				var msg = 'Some events are not valid for this type of mission type. Are you sure?';
				var onConfirm = function (e) {

					$.each(invalidEvents, function (index, event) {
						event.setEventType(-1);
					});

					$.each(invalidSubEvents, function(index, event){
						event.setSubEventType(-1);
					});

					VRC.CurrentVoyage.refresh();
				};
				var onCancel = function (e) {
					$(_this).val(oldMissionType);
					//reset the missionType and active eventTypes.
					currentVoyage.setMissionType(oldMissionType);
					VRC.MissionTypeService.init();
				};
				VRC.ConfirmationModal.show({msg: msg, onConfirm: onConfirm, onCancel: onCancel});
			}
			else {
				VRC.CurrentVoyage.refresh();
			}

		});
	};

	return {
		init: init
	};
})();